module.exports = __webpack_public_path__ + "img/mobile.227bd341.png";